/**
 * Úklid osiřelých položek "Versandgewicht-Einheit" v košíku.
 *
 * PROČ:
 * Konfigurátor přidává ke každé skupině front systémovou položku, jejíž
 * množství nese hmotnost zásilky — z ní Shopify počítá cenu dopravy.
 * Když zákazník konfigurátorové položky z košíku smaže, tahle položka
 * zůstane viset. V košíku ji sice cart-update.js skryje, ale checkout
 * (hostovaný Shopify) o tom neví a naúčtuje dopravu podle staré hmotnosti.
 *
 * JAK:
 * Váhová položka nese v properties `_addId`, stejné jako fronty přidané
 * ve stejném kroku. Když v košíku není žádná NEváhová položka se stejným
 * `_addId`, hmotnost už nemá k čemu patřit a odstraní se.
 *
 * Bezpečnostní zásady:
 *  - maže se jen varianta WEIGHT_VARIANT_ID a jen bez odpovídajících front,
 *  - běží pouze na /cart (do checkoutu se theme JS stejně nedostane),
 *  - po úklidu jeden reload, chráněný proti smyčce.
 */
(function () {
  const WEIGHT_VARIANT_ID = 55004244148488;
  // Příplatek za nadrozměr — stejný princip jako váhová položka: cenu nese sazba
  // jeho profilu dopravy, takže osiřelý řádek by zákazníkovi účtoval 14 € navíc.
  const SURCHARGE_INFO = 'System-Versandzuschlag';
  // Příplatek se účtuje JEDNOU za objednávku, když je v košíku aspoň jeden kus delší
  // než limit (K7, 22. 9. 2026). Nepatří ke konkrétnímu plánu (_addId) — rozhoduje
  // se podle rozměrů v řádcích („Abmessungen: 59.6 x 217.2 cm"). Limit = oversize_cm
  // ze snippets/bp-shipping-rules.liquid (FrontenCatalogService::SHIPPING).
  const OVERSIZE_CM_FALLBACK = 110;
  const RELOAD_GUARD = 'bpWeightCleanupDone';

  function oversizeLimit() {
    const cfg = window.bpShipping || {};
    return Number(cfg.oversize_cm) || OVERSIZE_CM_FALLBACK;
  }

  /**
   * Má řádek fronty kus delší než limit? Čísla z „Abmessungen" (i Eckblende s více rozměry).
   * Jen fronty z planerů (mají `_productId`) — skříně ze Schrankplaneru nesou taky
   * „Abmessungen", ale příplatek za nadrozměr se jich netýká.
   */
  function lineOversize(props, limit) {
    if (!props._productId) return false;
    const dims = String(props.Abmessungen || props['Maße'] || '');
    return (dims.match(/\d+(?:[.,]\d+)?/g) || []).some(n => parseFloat(n.replace(',', '.')) > limit);
  }

  async function cleanupOrphanedWeight() {
    if (!window.location.pathname.includes('/cart')) return;

    let cart;
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      cart = await res.json();
    } catch (e) {
      return; // výpadek sítě nesmí rozbít košík
    }

    if (!cart || !Array.isArray(cart.items)) return;

    const liveAddIds = new Set();
    const weightLines = [];
    const surchargeLines = [];
    const limit = oversizeLimit();
    let hasOversize = false;

    cart.items.forEach(item => {
      const props = item.properties || {};
      const addId = props._addId || null;

      if (props._Info === SURCHARGE_INFO) {
        surchargeLines.push({ key: item.key });
      } else if (item.variant_id === WEIGHT_VARIANT_ID) {
        weightLines.push({ key: item.key, addId: addId });
      } else {
        if (addId) liveAddIds.add(addId); // fronty, ke kterým hmotnost patří
        if (lineOversize(props, limit)) hasOversize = true;
      }
    });

    if (weightLines.length === 0 && surchargeLines.length === 0) return;

    const orphans = weightLines.filter(w => !w.addId || !liveAddIds.has(w.addId));
    // Příplatek: bez dlouhého kusu pryč celý, jinak ponechat právě jeden
    // (starší košíky ho mají za každý plán zvlášť).
    orphans.push(...(hasOversize ? surchargeLines.slice(1) : surchargeLines));
    if (orphans.length === 0) {
      sessionStorage.removeItem(RELOAD_GUARD);
      return;
    }

    for (const orphan of orphans) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: orphan.key, quantity: 0 })
        });
      } catch (e) {
        console.warn('[bp] Versandgewicht konnte nicht entfernt werden', e);
      }
    }

    // Přepočítat dopravu — jen jednou, ať nevznikne smyčka reloadů
    if (!sessionStorage.getItem(RELOAD_GUARD)) {
      sessionStorage.setItem(RELOAD_GUARD, '1');
      window.location.reload();
    }
  }

  document.addEventListener('DOMContentLoaded', cleanupOrphanedWeight);

  // Po změnách košíku (mazání položky, změna množství) DOM přepíše
  // morphSection() — proto kontrolujeme znovu, s klidovou prodlevou.
  let timer = null;
  new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(cleanupOrphanedWeight, 400);
  }).observe(document.body, { childList: true, subtree: true });
})();
